module.exports = __webpack_public_path__ + "media/svg-new/Ellipse 174-12c8173f.svg";